import AbstractModule from 'abstract/module';
import Network from 'system/network';
class LoginModule extends AbstractModule {
    /********************
     * Instance Methods *
     ********************/
    constructor(element, options = {}) {
        super(element, options);
        /**********************
         * Instance Variables *
         **********************/
        // dataset:Dataset
        // contentsViewTemplate
        this.rendered = 0;
        this.config.default({
            selector: null,
        });
        try {
            this.connection = Network.connection(this.config.get('connection', 'default'));
        }
        catch (error) {
            throw new Error("Unable to stablish a connection");
        }
        this.initialize();
        this.ready = true;
    }
    /**
     * Runs once after construction
     */
    initialize() {
        super.initialize();
        this.$element.on('submit', async (event) => {
            event.preventDefault();
            const payload = this.$element.serializeJSON();
            // if(payload.username && payload.password){
            const adapter = this.connection.adapter;
            await adapter.bridge.login(payload.username, payload.password);
            // }
        });
        // $(document).on('api-login,api-logout', (event, payload)=>{
        //      if(payload == true) {
        //         let element = $(this.element).closest('.modal')[0]
        //         let entity:EntityInterface = Entities.load(element)
        //         let target = <ModalEntity>Entities.get(entity.ID)
        //         // console.log(target)
        //         // console.log(target)
        //         // if(target)
        //         // target.close()
        //         // console.log(payload)
        //         // console.log(target.close())
        //         // entity.close()
        //     }
        // })
    }
    async submit() {
        if (this.$element.is('form'))
            this.$element.submit();
    }
    async show(action = null, payload = null) {
        this.config.set('current.action', action);
        if (!_.isObject(payload)) {
            this.config.set('current.payload', {});
        }
        else {
            this.config.set('current.payload', payload);
            this.update();
        }
    }
}
export default LoginModule;
export { LoginModule };
